"use client";

import { Typography } from "@/components/Typography";
import { Button } from "@/components/ui/button";
import { useAuthModal } from "@/hooks/auth/useAuthModal";
import { cn } from "@/lib/utils";

export const AuthAction = ({ textColorClass }: { textColorClass: string }) => {
  const { openLogin, openRegister } = useAuthModal();
  const handleLoginClick = () => {
    void openLogin("email");
  };

  const handleRegisterClick = () => {
    void openRegister();
  };

  return (
    <div className="flex items-center gap-4 lg:gap-0">
      <Button
        variant={"outline"}
        onClick={handleRegisterClick}
        className="bg-transperent border-none hover:bg-transperent hover:border-none"
      >
        <Typography
          variant="h6"
          className={cn("hover:underline", textColorClass)}
        >
          Register
        </Typography>
      </Button>

      <Button onClick={handleLoginClick} className="rounded-full h-[46px]">
        <Typography variant="h6" className="px-2">
          Login
        </Typography>
      </Button>
    </div>
  );
};
